export default "__VITE_ASSET__BY$XhcI5__"